import './commission-container.scss';

import { Box, Stack } from '@mui/material';
import {
  CreateBrokerageField,
  getCreateBrokerageFieldProps,
} from '@converge/data';
import { useEffect, useState } from 'react';

import { NewFormNumberInputAdornmentField } from '../../presentation';
import { UseFormReturn } from 'react-hook-form';
import { config } from '@converge/config';

export interface CreateBrokerageFields {
  [CreateBrokerageField.CompanyName]: string | null;
  [CreateBrokerageField.DbaName]: string | null;
  [CreateBrokerageField.Domain]: string;
  [CreateBrokerageField.GlobalParentCompany]: undefined | null | string;
  [CreateBrokerageField.PartnerEntity]: undefined | null | string;
  [CreateBrokerageField.Fein]: string;
  [CreateBrokerageField.Npn]: string;
  [CreateBrokerageField.ProgramUuid]: string | null | undefined;
  [CreateBrokerageField.CoverageRegionUuid]: string;
  [CreateBrokerageField.PrimaryStreet1]: string;
  [CreateBrokerageField.PrimaryStreet2]: string;
  [CreateBrokerageField.PrimaryCity]: string;
  [CreateBrokerageField.PrimaryRegionUuid]: string;
  [CreateBrokerageField.PrimaryCountryUuid]: string;
  [CreateBrokerageField.PrimaryPostalCode]: string;
  [CreateBrokerageField.Street1]: string;
  [CreateBrokerageField.Street2]: string;
  [CreateBrokerageField.City]: string;
  [CreateBrokerageField.RegionUuid]: string;
  [CreateBrokerageField.CountryUuid]: string;
  [CreateBrokerageField.PostalCode]: string;
  [CreateBrokerageField.PrimaryPhoneNumber]: string;
  [CreateBrokerageField.PrimaryPhoneNumberExtn]: string;
  [CreateBrokerageField.Digital]: number | undefined | null | string;
  [CreateBrokerageField.Wholesale]: number | undefined | null | string;
  [CreateBrokerageField.BusinessDevelopmentManager]: undefined | null | string;
  [CreateBrokerageField.Underwriter]: undefined | null | string;
  [CreateBrokerageField.UwRegion]: undefined | null | string;
  [CreateBrokerageField.PrimaryContactUuid]: undefined | null | string;
  [CreateBrokerageField.PrimaryContactEmail]: undefined | null | string;
  [CreateBrokerageField.BdmRegion]: undefined | null | string;
}

export interface CommissionBrokerageProps {
  formMethods: UseFormReturn<CreateBrokerageFields, unknown>;
  isReadOnly?: boolean;
}
export const CommissionBrokerage = ({
  formMethods,
  isReadOnly,
}: CommissionBrokerageProps) => {
  const [wholesale, setWholesale] = useState(
    Boolean(formMethods.getValues(CreateBrokerageField.Wholesale))
  );
  const [digital, setDigital] = useState(false);

  const wholesaleCommission = formMethods.getValues(
    CreateBrokerageField.Wholesale
  );
  const digitalCommission = formMethods.getValues(CreateBrokerageField.Digital);

  useEffect(() => {
    setWholesale(Boolean(wholesaleCommission));
  }, [wholesaleCommission]);

  useEffect(() => {
    setDigital(Boolean(digitalCommission));
  }, [digitalCommission]);
  return (
    <Stack className="commission-row-wrapper">
      <Stack className="brokerage-commission-container">
        <Box className="commission-row margin-top-0">
          {wholesale === true && (
            <>
              <img
                src={config.checkBox}
                className="check-box-icon"
                onClick={() => {
                  setWholesale(false);
                  formMethods.resetField(CreateBrokerageField.Wholesale);
                }}
                alt="selected checkBox"
                data-testid="selected-checkbox-wholesale"
              />
              <Box className="commission-text wholesale ">Wholesale</Box>
            </>
          )}
          {wholesale === false && (
            <>
              <img
                src={config.unselectedCheckBox}
                className="check-box-icon"
                onClick={() => setWholesale(true)}
                alt="unselected checkBox"
                data-testid="unselected-checkbox-wholesale"
              />
              <Box className="commission-text wholesale ">Wholesale</Box>
            </>
          )}
          <Box className="commission-field wholesale-text">
            <NewFormNumberInputAdornmentField
              {...getCreateBrokerageFieldProps(CreateBrokerageField.Wholesale)}
              adornmentText="%"
              isCheckBox={wholesale === false}
              data-testid="selected-text-wholesale"
              isItDismal={true}
            />
          </Box>
        </Box>
        <Box className="commission-row">
          {digital === true && (
            <>
              <img
                src={config.checkBox}
                className="check-box-icon"
                onClick={() => {
                  formMethods.resetField(CreateBrokerageField.Digital);
                  setDigital(false);
                }}
                alt="selected checkBox"
                data-testid="selected-checkbox-digital"
              />
              <Box className="commission-text digital">Digital</Box>
            </>
          )}
          {digital === false && (
            <>
              <img
                src={config.unselectedCheckBox}
                className="check-box-icon"
                onClick={() => setDigital(true)}
                alt="unselected checkBox"
                data-testid="unselected-checkbox-digital"
              />
              <Box className="commission-text digital">Digital</Box>
            </>
          )}
          <Box className="commission-field">
            <NewFormNumberInputAdornmentField
              // className="commission-field"
              {...getCreateBrokerageFieldProps(CreateBrokerageField.Digital)}
              dataTestid="selected-text-digital"
              width={'120px'}
              adornmentText="  %"
              isItDismal={true}
              isCheckBox={digital === false}
            />
          </Box>
        </Box>
      </Stack>
      <Box className="empty-space-middle"></Box>
      <Box className="empty-space-right"></Box>
    </Stack>
  );
};
